/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSharedWorkspacePermissionsResponse } from '../../models/get-shared-workspace-permissions-response';

export interface GetSharedWorkspacePermissions$Params {

/**
 * Workspace ID
 */
  workspaceId: number;
}

export function getSharedWorkspacePermissions(http: HttpClient, rootUrl: string, params: GetSharedWorkspacePermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSharedWorkspacePermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getSharedWorkspacePermissions.PATH, 'get');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSharedWorkspacePermissionsResponse>;
    })
  );
}

getSharedWorkspacePermissions.PATH = '/workspaces/shared/{workspaceId}/permissions';
